var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBusPassAccounts = function SvgBusPassAccounts(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "busPassAccounts_svg__a",
    width: 20,
    height: 20,
    x: -1,
    y: -2,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M19-2H-1v20h20z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#busPassAccounts_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "m8.906 11.012.89.717q.21.171.43.012t.143-.426l-.362-1.175 1.079-.855a.37.37 0 0 0 .116-.417q-.077-.247-.337-.247h-1.22l-.402-1.25q-.077-.267-.337-.268-.26 0-.337.268l-.401 1.25H6.925q-.26 0-.334.247a.37.37 0 0 0 .119.417l1.05.855-.361 1.215q-.077.267.13.426.206.159.422-.011zm-6.564 5.12q-.597 0-1.016-.432a1.45 1.45 0 0 1-.42-1.045V12.73q0-.2.096-.364a.6.6 0 0 1 .272-.246 3 3 0 0 0 1.023-.997q.387-.621.387-1.391t-.387-1.39a3 3 0 0 0-1.023-.998.6.6 0 0 1-.272-.246.7.7 0 0 1-.096-.364V4.81q0-.615.42-1.045.42-.432 1.016-.432H15.47q.597 0 1.017.432.42.431.42 1.045v1.925a.7.7 0 0 1-.096.364.6.6 0 0 1-.272.246q-.636.376-1.023.997a2.57 2.57 0 0 0-.387 1.391q0 .77.387 1.39.387.622 1.023.998a.6.6 0 0 1 .271.246q.096.165.096.364v1.925q0 .615-.42 1.045-.42.432-1.016.432z"
  }))));
};
export default SvgBusPassAccounts;